import { SVGProps, Ref, forwardRef } from 'react';

export const PenHyperstarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.503 1.357a2.927 2.927 0 0 1 4.14 4.14L4.64 15.5H.5v-4.14zM1.9 11.94v2.16h2.16l7.524-7.525-2.16-2.159zm11.752-9.592a1.527 1.527 0 0 0-2.159 0l-1.079 1.078 2.16 2.16 1.078-1.08a1.526 1.526 0 0 0 0-2.158"
                    fill="currentColor"
                />
                <path
                    d="M3 .5A9.5 9.5 0 0 0 5.5 3 9.5 9.5 0 0 0 3 5.5 9.5 9.5 0 0 0 .5 3 9.5 9.5 0 0 0 3 .5"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PenHyperstarOutlinedSize16Glyph.displayName = 'PenHyperstarOutlinedSize16Glyph';
